// Testing environment: call the API on the SAME origin so nginx proxies /api
// to the testing backend. An absolute host here sends this build at production.
// This file is gitignored, so it survives deploys.
const defaultApiUrl = "/";
const configuredApiUrl = (process.env.REACT_APP_API_URL || defaultApiUrl).trim();

export const api = configuredApiUrl === "/"
  ? ""
  : configuredApiUrl.replace(/\/+$/, "");
